/**
 *
 * Asynchronously loads the component for CustomIcons
 *
 */

import loadable from 'utils/loadable';

// Types
import { IconProps } from './types';

export default loadable<IconProps>(() =>
  import(
    /* webpackChunkName: "CustomIcons" */
    /* webpackPrefetch: true */
    './main'
  ),
);
